import { css } from "@emotion/css"

type Props = {
  children: React.ReactNode
  columns?: number
}

const SimpleGrid = ({ children, columns = 1 }: Props) => {
  return (
    <div className={styles.grid} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0px, 1fr))` }}>
      {children}
    </div>
  )
}

export default SimpleGrid

const styles = {
  grid: css`
    display: grid;
    row-gap: 9px;
    column-gap: 20px;
  `,
}
